var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M14.258 48.638h10.921v286.599H14.258v42.637h106.311L66.762 506h38.664l60.2-128.126h180.748L406.574 506h38.664l-53.807-128.126h106.311v-42.637h-10.921V48.638h10.921V6H14.258z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#268b8e",
    d: "M25.854 17.596h460.293v19.445H25.854zM25.854 346.833h460.293v19.445H25.854z",
    opacity: 1,
    "data-original": "#00abfe",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eae5db",
    d: "M36.775 37.041h438.45v309.792H36.775z",
    opacity: 1,
    "data-original": "#eae5db",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m84.21 494.404 53.807-128.125h20.245L98.061 494.404zM427.79 494.404l-53.807-128.125h-20.245l60.201 128.125z",
    opacity: 1,
    "data-original": "#a369f7",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb020",
    d: "M359.38 183.856a91.4 91.4 0 0 1-17.532 53.964l-74.232-53.964V92.092a91.764 91.764 0 0 1 91.764 91.764z",
    opacity: 1,
    "data-original": "#ffb020",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7ad001",
    d: "M330.221 245.891a91.762 91.762 0 0 1-166-53.964h91.764z",
    opacity: 1,
    "data-original": "#7ad001",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be9045",
    d: "M253.193 86.978v91.764h-91.764a91.764 91.764 0 0 1 91.764-91.764zM69.289 104.345h87.618a9.069 9.069 0 0 1 9.069 9.069v11.264H69.289a4.535 4.535 0 0 1-4.535-4.535V108.88a4.535 4.535 0 0 1 4.535-4.535z",
    opacity: 0.45098039215686275,
    "data-original": "#ff605b",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7ad001",
    d: "M106.315 283.713H203v11.264a9.069 9.069 0 0 1-9.069 9.069h-87.616a4.535 4.535 0 0 1-4.535-4.535v-11.263a4.535 4.535 0 0 1 4.535-4.535z",
    opacity: 1,
    "data-original": "#7ad001",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb020",
    d: "M436.497 94.311H339.81V83.048a9.069 9.069 0 0 1 9.069-9.069h87.618a4.535 4.535 0 0 1 4.535 4.535v11.263a4.535 4.535 0 0 1-4.535 4.535z",
    opacity: 1,
    "data-original": "#ffb020",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    width: 82.576,
    height: 88.934,
    x: 364.67,
    y: 237.82,
    fill: "#be9045",
    rx: 6.252,
    opacity: 0.45098039215686275,
    "data-original": "#ff605b",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1d1d3d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.528,
    height: 6.393,
    x: 373.194,
    y: 256.533,
    rx: 1.426,
    fill: "#1d1d3d",
    opacity: 1,
    "data-original": "#1d1d3d",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65.528,
    height: 6.393,
    x: 373.194,
    y: 271.982,
    rx: 1.426,
    fill: "#1d1d3d",
    opacity: 1,
    "data-original": "#1d1d3d",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65.528,
    height: 6.393,
    x: 373.194,
    y: 287.432,
    rx: 1.426,
    fill: "#1d1d3d",
    opacity: 1,
    "data-original": "#1d1d3d",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65.528,
    height: 6.393,
    x: 373.194,
    y: 302.882,
    rx: 1.426,
    fill: "#1d1d3d",
    opacity: 1,
    "data-original": "#1d1d3d",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.9f725e6a5a0d8179347c64cb2c29ebb2.svg";
export { ForwardRef as ReactComponent };